import React from 'react'

export default function LayoutsMarketing(props) {
  return (
    <section><a className="anchor" id="marketing"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/marketing.html"><img src="images/marketing.png" alt="Screenshot of the marketing snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12  grid__col-lg-6">
            <h2>Marketing layout</h2>
            Example of using -
            <ul>
              <li><a href={props.staticVersion === true ? '#core/navigation' : 'Core#navigation'}>Navigation</a></li>
              <li><a href={props.staticVersion === true ? '#core/alerts' : 'Core#alerts'}>Alerts</a></li>
              <li><a href={props.staticVersion === true ? '#core/wells' : 'Core#wells'}>Wells</a></li>
              <li><a href={props.staticVersion === true ? '#core/buttons' : 'Core#buttons'}>Buttons</a></li>
              <li><a href={props.staticVersion === true ? '#components/mediaObjects' : 'Components#mediaObjects'}>Media Objects</a></li>
              <li><a href={props.staticVersion === true ? '#core/grid' : 'Core#grid'}>Grid</a></li>
            </ul>
            <p><a className="btn" href="samples/marketing.html">View live preview</a>&nbsp;<a className="btn" href="samples/marketing.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsMarketing.js